import { formatEnumName, formatEnumValue } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const removeEnumValueStmtInstruction = `
#### Remove enum values
- Syntax: \`alter enum <enum_name> remove <value1>[, <value2>]';\`
- Example: \`alter enum orderStatus remove returned;\``;
export const stmtRemoveEnumValue = ({ enumName, values }) => {
    return `alter enum ${enumName} remove ${values.join(', ')};`;
};
export const stmtForHumanRemoveEnumValue = ({ enumName, values }) => {
    return `Remove the values __${values.join(', ')}__ from the enum __${enumName}__.`;
};
export const removeEnumValueHandler = createSchemaStatementHandler({
    type: 'remove enum value',
    parse: line => {
        const match = /^alter enum (?<enumName>[\w_]+) remove (?<values>[\w, ]+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove enum value',
                enumName: formatEnumName(match.groups.enumName),
                values: match.groups.values.split(', ').map(value => formatEnumValue(value)),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRemoveEnumValue,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.updateEnumValues(stmt.enumName, it => it.filter(v => !stmt.values.includes(v))));
    },
});
//# sourceMappingURL=RemoveEnumValueStmt.js.map